module.exports = {
          srcSet: __webpack_public_path__ + "public/a3ecb5f2ed826b31726148623e6ee1d5-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/a3ecb5f2ed826b31726148623e6ee1d5-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/a3ecb5f2ed826b31726148623e6ee1d5-80.png",
          toString:function(){return __webpack_public_path__ + "public/a3ecb5f2ed826b31726148623e6ee1d5-80.png"},
          
          width: 80,
          height: 80
        }